import CasinoList from "./list";
import {Link, useNavigate, useParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import associateServices from "../../services";
import {useSelector} from "react-redux";
import SvgIcon from "../../components/svg-icon";
import {useTranslation} from "react-i18next";
import stringHelper from "../../helpers/string-helper";
import MiniSlider from "../homepage/mini-slider";
import {useLocation} from 'react-router-dom';

const CasinoGroup = () => {

    const location = useLocation();
    const {title, image} = location.state || {};


    const {type} = useParams()
    const {t} = useTranslation()
    const {gameTypes, liveCasinoTypes} = useSelector(state => state.dataReducer)


    const {i18n} = useTranslation();
    const currentLanguage = i18n.language; // Get the current language
    const [wholeTypes, setWholeTypes] = useState([])

    useEffect(() => {
        setWholeTypes(['table-games', 'blackjack', 'roulette', 'poker', 'baccarat', 'live-lobby', 'live-casino'].includes(type) ? liveCasinoTypes : gameTypes)
    }, [type])


    const [providersList, setProvidersList] = useState([])

    useEffect(() => {
        setProvidersList([])
        associateServices.getGameProvidersGroup({type}).then(handleProviders)
    }, [type])

    const handleProviders = response => setProvidersList(response?.data || [])
    return (
        <>
            <div className="section section--first">
                <MiniSlider
                    page={['table-games', 'blackjack', 'roulette', 'poker', 'baccarat', 'live-lobby', 'live-casino']?.includes(type) ? 'live-casino' : 'slots'}/>
            </div>
            <div className="section section--first">
                <div className="container">
                    {/*<CasinoMainSlider title={t(`sidebar.${type}`)} type={type}/>*/}
                    <div className="col-12 d-flex  align-items-center gap-2">
                        {/*<h1 className="section__title section__title--head">{t(`sidebar.${type}`)}</h1>*/}
                        <h1 className="section__title section__title--head">{title}</h1>
                    </div>
                </div>
            </div>
            {/*<div className="container">*/}
            {/*    <div className="col-12">*/}
            {/*        <ul className="tags">*/}
            {/*            {*/}
            {/*                wholeTypes?.map(gameType =>*/}
            {/*                    <li*/}
            {/*                        className={`${gameType.key === type ? 'active' : ''}`}*/}
            {/*                        key={gameType.key}>*/}
            {/*                        <Link*/}
            {/*                            to={stringHelper.getLocalizedPath(currentLanguage, gameType.path)}>*/}
            {/*                            <SvgIcon id={gameType.icon}/>*/}
            {/*                            {t(`sidebar.${gameType.key}`)}*/}
            {/*                        </Link>*/}
            {/*                    </li>*/}
            {/*                )*/}
            {/*            }*/}
            {/*        </ul>*/}
            {/*    </div>*/}
            {/*</div>*/}
            <div className="section section--last pt-24">
                <div className="container">
                    <CasinoList {...{type, providersList}}/>
                </div>
            </div>
        </>

    )

}

export default CasinoGroup
